<template>
  <div>
    <van-sticky :offset-top="46">
      <van-search
        v-model="queryParams.address"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
      <van-dropdown-menu>
        <van-dropdown-item v-model="queryParams.orderStatus" :options="option" @change="handleRefresh"/>
        <van-dropdown-item title="筛选" ref="item">
          <van-cell title="配送日期" :value="queryParams.deliveryDate" @click="show = true" />
  <!--        <div style="padding: 5px 16px;">-->
  <!--          <van-button type="danger" block round @click="() => { this.$refs.item.toggle(); handleRefresh()}">-->
  <!--            确认-->
  <!--          </van-button>-->
  <!--        </div>-->
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-calendar v-model="show" :show-confirm="false" @confirm="onDeliveryDateConfirm" :min-date="minDate" :style="{ height: '500px' }"/>
    <page-list ref='pageList' request-url="/ordersub" :getParams="getQueryParams">
      <template #row="{row}">
        <div style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-row :ref="'row'+row.id" @click.stop="()=>{
            $router.push({name:'StockUpList',params: {subId:row.id}})
          }">
          <van-sticky :container="$refs['row'+row.id]" style="  right: 0px;
                                                                position: absolute;
                                                                writing-mode: vertical-lr;
                                                                background-color: rgb(255, 151, 106);
                                                                border: 1px solid rgb(255, 151, 106);
                                                                color: #FFFFFF;
                                                                line-height: 18px;
                                                                border-radius: 5px;">
              配货明细
            </van-sticky>
            <van-col span="18">订单编号: {{row.orderNo}}</van-col>
            <van-col span="6">{{formatOrderStatus(row.orderStatus)}}</van-col>
            <van-col span="24">下单时间: {{row.createTime}}</van-col>
            <van-col span="12">账户编号: {{row.accountId}}</van-col>
            <van-col span="12">送达日期: {{row.deliveryDate}}</van-col>
            <van-col span="12">订单金额: {{row.amount}}</van-col>
            <van-col span="12">结算金额: {{row.supplierPayAmount}}</van-col>
            <van-col span="12">联系人: {{row.contacts}}</van-col>
            <van-col span="12">联系电话: {{row.contactsPhone}}</van-col>
            <van-col span="24">收货地址: {{row.address}}</van-col>
          </van-row>
          <van-row type="flex" justify="center" v-if="row.orderStatus === 2" v-has="'STAT:PURCHASE'">
            <van-col span="12"><van-button type="info" size="small" block @click="openDeliveryDateDrawer(row)">调整</van-button></van-col>
            <van-col span="12" ><van-button type="default" size="small" block @click="onDelivery(row.id)">发货</van-button></van-col>
          </van-row>
        </div>
      </template>
    </page-list>
    <van-submit-bar v-has="'STAT:PURCHASE'">
      <template #button>
        <van-button type="primary" round block @click="openPurchaseDrawer">生成采购单</van-button>
      </template>
    </van-submit-bar>
    <down-drawer ref='deliveryDateDrawer' @close="handleRefresh" @confirm="handleDeliveryDate" title="调整配送日期" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            v-model="model.deliveryDate"
            name="deliveryDate"
            label="配送日期"
            placeholder="请输入配送日期"
            @click=" deliveryDateShow = true"
            :rules="[{ required: true, message: '配送日期不能为空' }]"
          />
          <van-field name="syncMainOrder" label="同步关联订单">
            <template #input>
              <van-checkbox v-model="allOrder" shape="square" />
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>

    <down-drawer ref='generatePurchaseDrawer' @close="handleRefresh" @confirm="generatePurchase" title="生成采购单" >
      <template #content>
        <van-form ref="purchaseForm" :validate-first="true" :show-error-message="false">
          <van-field
            v-model="purchaseDay"
            name="purchaseDay"
            label="配送日期"
            placeholder="请输入配送日期"
            @click=" purchaseDayShow = true"
            :rules="[{ required: true, message: '配送日期不能为空' }]"
          />
        </van-form>
      </template>
    </down-drawer>
    <van-calendar v-model="deliveryDateShow" :show-confirm="false" @confirm="onDeliveryDateConfirm2"  :style="{ height: '500px' }"/>
    <van-calendar v-model="purchaseDayShow" :show-confirm="false" @confirm="onDeliveryDateConfirm3"  :style="{ height: '500px' }"/>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'OrderList',
  components: { PageList },
  created () {
    this.queryParams.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.purchaseDay = this.$moment(new Date()).format('YYYY-MM-DD')
  },
  data () {
    const that = this
    return {
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      deliveryDateShow: false,
      purchaseDayShow: false,
      show: false,
      allOrder: false,
      model: {},
      purchaseDay: null,
      queryParams: {
        orderStatus: -1,
        deliveryDate: '',
        address: null
      },
      minDate: new Date(that.$moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')),
      option: [
        { text: '所有订单', value: -1 },
        { text: '待发货', value: 2 },
        { text: '待收货', value: 3 },
        { text: '已签收', value: 4 }
      ]
    }
  },
  computed: {

  },
  methods: {
    formatOrderStatus (orderStatus) {
      if (orderStatus === 0) {
        return '已取消'
      } else if (orderStatus === 1) {
        return '待付款'
      } else if (orderStatus === 2) {
        return '待发货'
      } else if (orderStatus === 3) {
        return '待收货'
      } else if (orderStatus === 4) {
        return '已签收'
      } else if (orderStatus === 5) {
        return '申请退货中'
      } else if (orderStatus === 6) {
        return '退货中'
      } else if (orderStatus === 7) {
        return '退货完成'
      }
      return '未知状态'
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      if (this.queryParams.orderStatus !== -1) {
        param.orderStatus = this.queryParams.orderStatus
      }
      param.deliveryDate = this.queryParams.deliveryDate

      param.address = this.queryParams.address
      return { params: param }
    },
    openDeliveryDateDrawer (row) {
      this.model = {}
      this.$refs.deliveryDateDrawer.show = true
      this.model.deliveryDate = row.deliveryDate
      this.allOrder = false
      this.model.id = row.id
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    onDeliveryDateConfirm (date) {
      this.show = false
      this.queryParams.deliveryDate = this.$moment(date).format('YYYY-MM-DD')
      this.$refs.item.toggle()
      this.handleRefresh()
    },
    onDeliveryDateConfirm2 (date) {
      this.deliveryDateShow = false
      this.model.deliveryDate = this.$moment(date).format('YYYY-MM-DD')
    },
    onDeliveryDateConfirm3 (date) {
      this.purchaseDayShow = false
      this.purchaseDay = this.$moment(date).format('YYYY-MM-DD')
    },
    onDelivery (id) {
      const that = this
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认已发货?'
      }).then(() => {
        that.$api.shop.handleDelivery(id).then(response => {
          that.$toast.success('发货成功')
          that.handleRefresh()
        }).catch(() => {

        })
      }).catch(() => {

      })
    },
    handleDeliveryDate () {
      const that = this
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.shop.changeDeliveryDate(this.model.id, this.model.deliveryDate, this.allOrder).then(response => {
          if (response.success) {
            that.$toast.success('调整成功')
          } else {
            that.$toast.fail(response.message)
          }
          this.$refs.deliveryDateDrawer.show = false
          this.handleRefresh()
        }).catch(() => {

        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    openPurchaseDrawer () {
      this.purchaseDay = this.$moment(new Date()).format('YYYY-MM-DD')
      this.$refs.generatePurchaseDrawer.show = true
    },
    generatePurchase () {
      if (!this.purchaseDay) {
        this.$toast.fail('送达时间不能为空')
        return
      }
      this.$api.shop.generatePurchaseOrder(this.purchaseDay).then(response => {
        if (response.success) {
          this.$toast.success('生成成功')
        } else {
          this.$toast.fail(response.message)
        }
        this.$refs.generatePurchaseDrawer.show = false
      }).catch(() => {
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  /*/deep/.van-sticky{*/
  /*  transform: translateZ(0);*/
  /*  -webkit-transform: translateZ(0);*/
  /*}*/
</style>
